import React from 'react';
import BroadlyAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/BroadlyAppIcon';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import BroadlyButton from '../OtherComponents/BroadlyButton';

const BroadlyStrategy = {
  previewInfo: {
    name: 'Broadly',
    newTab: true,
    iconSvg: <BroadlyAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'Broadly',
    category: 'Online review generation',
    details: (
      <>
        By providing expert service to your customers, you’re already well on your way to building
        your business legacy. Let Broadly help you with one of the most essential parts of lasting
        success: providing meaningful customer experiences.
        We give you the tools to help you easily attract new customers and interact with them on a personal level
        so you can build lifelong relationships and ensure your business thrives now and into the future.
        <br />
        Discover which ads, keywords, and campaigns bring valuable leads over the phone and on the web.
        <br />
        <br />
        Broadly will help you: attract and capture leads, streamline your communications by email and text,
        gather feedback, reviews, and more. Automatically send your customers review requests with the
        Broadly & Housecall Pro integration.
      </>
    ),
    iconSvg: <BroadlyAppIcon size="superJumbo" />,
  },
  media: {
    youtubeId: 'JOO8AbxV_Yk',
  },
  sellingPoints: {
    headline: 'Hear from our customers',
    description: (
      <>
        "Broadly has helped us immensely and is a permanent part of our team.
        Our only regret is that we didn't find them sooner." - Keemer Plumbing LLC
        <br />
        <br />
        "We have loved Broadly so far. It has helped us to follow up with our clients
        when needed and build ratings quickly. Highly recommend using Broadly if you want
        to position your business for success online." - Sunshine Window Cleaning
      </>
    ),
  },
  price: {
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" color="textSecondary">
            Monthly
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right">
            $277 per month
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography align="left" color="textSecondary">
            Annually
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right">
            $222 per month
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography align="right">
            + Waived setup fee for HCP users
          </Typography>
        </Grid>
      </Grid>
    ),
    price: '',
    hideToggle: true,
    appActionButton: <BroadlyButton />,
  },
  supportContacts: [
    { type: 'Phone', contact: '(800) 727 0445' },
    { type: 'Support', contact: <a href="mailto:support@broadly.com">support@broadly.com</a> },
    { type: 'Help center', contact: <a href="https://broadlyhelp.force.com/">https://broadlyhelp.force.com/</a> },
  ],
};

export default BroadlyStrategy;
